import { useQueryClient, useMutation } from "@tanstack/react-query";

import { getAuth, isProfileAuth } from "~/providers/store/auth/getters";
import { DisplayError, DisplayErrorCodeEnum } from "~/utils/display-error";

import { tillsKeys } from "../keys";
import { updateTill } from "../requests";
import { type UpdateTillRequest } from "../types";

export function useUpdateTill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateTillRequest["body"]) => {
      const auth = getAuth();
      if (!isProfileAuth(auth)) {
        throw new DisplayError(DisplayErrorCodeEnum.PROFILE_NOT_SELECTED);
      }

      return updateTill(auth.tillId, body);
    },
    onSuccess: async (till) => {
      await queryClient.invalidateQueries({
        queryKey: tillsKeys.detail(till.id)
      });
    }
  });
}
